<script setup lang="ts">
// 定义 props
const props = defineProps({
  error: Object
})

// 使用 i18n
const { t } = useI18n()

// 处理错误
const handleError = () => {
  clearError({ redirect: '/' })
}
</script>

<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950">
    <div class="text-center p-8 max-w-md">
      <h1 class="text-4xl font-bold text-gray-800 dark:text-white mb-4">{{ t('error.title') }}</h1>
      <p class="text-gray-600 dark:text-gray-300 mb-6">
        {{ props.error?.message || t('error.defaultMessage') }}
      </p>
      <button 
        @click="handleError" 
        class="px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors duration-200"
      >
        {{ t('error.backToHome') }}
      </button>
    </div>
  </div>
</template> 